const breakpoints = [
  'mobile',
  'phablet',
  'tablet',
  'desktop',
  'large'
];

export {
  breakpoints
};
